import { commonEnvironment } from './common.environment';

export const environment = {
  ...commonEnvironment,
  envName: 'prod',
  production: true,
  authServerUrl: 'https://auth.cloud.triarc-labs.com/auth',
  serverApiUrl: 'https://my.siz.ch',
};
